import { render, staticRenderFns } from "./ColaboradorLayout.vue?vue&type=template&id=2d641c43&scoped=true"
import script from "./ColaboradorLayout.vue?vue&type=script&lang=js"
export * from "./ColaboradorLayout.vue?vue&type=script&lang=js"
import style0 from "./ColaboradorLayout.vue?vue&type=style&index=0&id=2d641c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d641c43",
  null
  
)

export default component.exports